import { Expose } from 'class-transformer';
import { SurveyElement } from './element';
import { TEXTFIELD_BUTTON_ACTION_TYPES } from '@/models/enums/textfield-button-action-types.enum';

export class SurveyAiGeneratedTextFieldElement extends SurveyElement {
  @Expose({ name: 'generate_again_text' })
  regenerateButtonLabel!: string;

  @Expose({ name: 'placeholder' })
  label!: string;

  @Expose()
  question!: string;

  @Expose({ name: 'ai_text_generator_settings' })
  aiTextGeneratorSettings?: string;

  @Expose({ name: 'action_button' })
  actionButton!: {
    actions: TEXTFIELD_BUTTON_ACTION_TYPES;
    text: string;
  };
}
